import { render, staticRenderFns } from "./stock-option-label.vue?vue&type=template&id=0f1ea8d1&scoped=true&"
import script from "./stock-option-label.vue?vue&type=script&lang=js&"
export * from "./stock-option-label.vue?vue&type=script&lang=js&"
import style0 from "./stock-option-label.vue?vue&type=style&index=0&id=0f1ea8d1&prod&scoped=true&lang=scss&"
import style1 from "./stock-option-label.vue?vue&type=style&index=1&id=0f1ea8d1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1ea8d1",
  null
  
)

export default component.exports